import React from 'react';
import { motion } from 'framer-motion';
import { CalendarDaysIcon, BusIcon, DumbbellIcon, WavesIcon, TreesIcon, FlagIcon, FlowerIcon, PaletteIcon } from 'lucide-react';
const ACTIVITIES = [{
  icon: CalendarDaysIcon,
  label: 'Community events and social gatherings'
}, {
  icon: BusIcon,
  label: 'Day trips and excursions'
}, {
  icon: DumbbellIcon,
  label: 'Fitness classes and wellness programs'
}, {
  icon: WavesIcon,
  label: 'Indoor heated pool'
}, {
  icon: TreesIcon,
  label: 'Walking and outdoor recreation'
}, {
  icon: FlagIcon,
  label: 'Putting green and golf activities'
}, {
  icon: FlowerIcon,
  label: 'Community gardening'
}, {
  icon: PaletteIcon,
  label: 'Arts, culture, dining, and local outings'
}];
export function ActiveLiving() {
  return <section id="active" className="w-full bg-forest py-20 lg:py-28" data-id="element-7" data-mp="5rzyz5u9j0yj">
      <div className="mx-auto max-w-7xl px-5 lg:px-8" data-id="element-8" data-mp="asdx9w62awjd">
        <div className="grid items-center gap-10 lg:grid-cols-[1.4fr_1fr]" data-id="element-9" data-mp="2ilw1f52z720p">
          <div className="max-w-2xl" data-id="element-10" data-mp="2ijt563b8ccnj">
            <span className="text-sm font-semibold uppercase tracking-[0.2em] text-gold-light" data-id="element-11" data-mp="2dnukoqt0vese">
              Daily Life at Brightwood
            </span>
            <h2 className="mt-3 font-display text-3xl leading-tight text-white sm:text-4xl" data-id="element-12" data-mp="2rgahvaz8sile">
              Active Senior Living On Your Terms
            </h2>
            <p className="mt-4 font-serif text-lg leading-relaxed text-white/85" data-id="element-13" data-mp="1zo2zo6438y4w">
              Whether you enjoy staying active, meeting new friends, or
              exploring new interests, our independent senior living community
              offers opportunities to live each day to the fullest.
            </p>
          </div>
          <motion.div initial={{
          opacity: 0,
          y: 24
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.6
        }} className="overflow-hidden rounded-md shadow-lg ring-1 ring-white/10" data-id="element-14" data-mp="23qzqgk3s80jx">
            <img src="https://cdn.magicpatterns.com/uploads/dc5PzLmm6Y8Bo7JTg2zQbW/IMG_0241-2.png" alt="Tree-lined green grounds of the Brightwood community on a sunny day" className="h-64 w-full object-cover object-center lg:h-72" data-id="element-15" data-mp="2lsdibnslt0ko" />
          </motion.div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-16" data-mp="1y29d5bzrosrk">
          {ACTIVITIES.map((activity, i) => {
          const Icon = activity.icon;
          return <motion.div key={activity.label} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-60px'
          }} transition={{
            duration: 0.45,
            delay: i % 4 * 0.08
          }} className="flex items-center gap-4 rounded-md bg-forest-light/50 p-5 ring-1 ring-white/10" data-id="element-17" data-mp="27sb54ev8qvbr" data-mpi={i}>
                <span className="flex h-11 w-11 flex-none items-center justify-center rounded-md bg-gold" data-id="element-18" data-mp="tu0wo72exybw">
                  <Icon className="h-5 w-5 text-forest-dark" data-id="element-19" data-mp="ouxz17oriudy" />
                </span>
                <span className="text-[15px] font-medium leading-snug text-white" data-id="element-20" data-mp="k0tvkyeph4hm">
                  {activity.label}
                </span>
              </motion.div>;
        })}
        </div>

        <div className="mt-12 flex flex-col items-start gap-6 border-t border-white/15 pt-10 sm:flex-row sm:items-center sm:justify-between" data-id="element-21" data-mp="a1vxb3rh9wlf">
          <p className="max-w-2xl font-serif text-lg italic leading-relaxed text-white/80" data-id="element-22" data-mp="12r1443e2fcf">
            Our dedicated activities director keeps the calendar full while
            giving you the freedom to participate as much or as little as you'd
            like.
          </p>
          <a href="#connect" className="flex-none rounded-sm bg-gold px-7 py-3.5 text-sm font-bold uppercase tracking-widest text-forest-dark transition-colors hover:bg-gold-light" data-id="element-23" data-mp="1rfqh26bx6p4m">
            Schedule Your Tour
          </a>
        </div>
      </div>
    </section>;
}